import "./index.scss";
import { isValidNumberWithinBoundary } from "utils/numbers";
import { defaultMessage } from "./utils/constants";
import { usePriceRange } from "./utils/usePriceRange";

export const DiscountPriceRange = ({
  hasFilters,
  totalCount,
  priceRange,
  setPriceRange
}) => {
  const {
    range,
    rangeMessage,
    validationError,
    setRange,
    setRangeWithValidations
  } = usePriceRange({ priceRange, setPriceRange });

  const maxRange = { min: 0, max: 2000 };
  const isValidNumber = (value) => isValidNumberWithinBoundary(value, maxRange);

  const handleInputChange = (type, value) => {
    if (isValidNumber(value)) {
      setRange({ ...range, [type]: value });
    }
  };

  const handleInputSubmit = () => {
    const [min, max] = Object.values(range).map((elem) => {
      const num = parseFloat(elem);
      return isNaN(num) ? "" : Math.round(num);
    });

    const isNotEmpty = min !== "" || max !== "";
    if (isNotEmpty) setRangeWithValidations(min, max);
  };

  const handleInputKeyDown = (keyCode) => {
    if (keyCode === "Enter" || keyCode === "NumpadEnter") handleInputSubmit();
  };

  const shouldDisplayResults =
    hasFilters && (!rangeMessage || rangeMessage === defaultMessage);

  return (
    <div className={`discount-price-range ${validationError && "error"}`}>
      <div className="range-container">
        <div className="range-input">
          <p className="label">Minimum</p>
          <span className={`dollar ${!!range.min && "active"}`}>$</span>
          <input
            onChange={(event) => handleInputChange("min", event.target.value)}
            onKeyDown={(event) => handleInputKeyDown(event.code)}
            onBlur={handleInputSubmit}
            placeholder="5"
            value={range.min}
          />
        </div>
        <div className="range-input">
          <div className="label">Maximum</div>
          <span className="dollar">$</span>
          <input
            onChange={(event) => handleInputChange("max", event.target.value)}
            onKeyDown={(event) => handleInputKeyDown(event.code)}
            onBlur={handleInputSubmit}
            placeholder="2000"
            value={range.max}
          />
        </div>
      </div>
      {shouldDisplayResults ? (
        <span className="range-results">{totalCount} Results</span>
      ) : (
        <p className="range-message">{rangeMessage}</p>
      )}
    </div>
  );
};
